import React from "react";
import { shape, func, bool, string } from "prop-types";
import { Link } from "@quintype/components";

const MenuItem = ({ item, itemClick, dataTagCategory }) => {
  if (item["item-type"] === "placeholder") {
    return <span>{item.title}</span>;
  } else if (item["item-type"] === "link") {
    return (
      <a
        href={item.completeUrl}
        rel="noopener noreferrer"
        onClick={itemClick}
        data-tracking-category={dataTagCategory}
        data-tracking-action="Click"
        data-tracking-label={item.title}
      >
        {item.title}
      </a>
    );
  } else {
    return (
      <Link
        href={item.completeUrl}
        rel="noopener noreferrer"
        callback={itemClick}
        data-tracking-category={dataTagCategory}
        data-tracking-action="Click"
        data-tracking-label={item.title}
      >
        {item.title}
      </Link>
    );
  }
};

MenuItem.propTypes = {
  item: shape({
    isExternalLink: bool,
    completeUrl: string,
    title: string,
  }),
  itemClick: func,
  dataTagCategory: string,
};

export { MenuItem };
